/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CreateServiceAccountDtoBase
 * auto generated base class for the model CreateServiceAccountDtoModel.
 */
export const CreateServiceAccountDtoModelBase = ModelBase
  .named('CreateServiceAccountDto')
  .props({
    __typename: types.optional(types.literal("CreateServiceAccountDto"), "CreateServiceAccountDto"),
    id: types.union(types.undefined, types.integer),
    uuid: types.union(types.undefined, types.string),
    token: types.union(types.undefined, types.string),
    expiresOn: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CreateServiceAccountDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get token() { return this.__attr(`token`) }
  get expiresOn() { return this.__attr(`expiresOn`) }
}
export function selectFromCreateServiceAccountDto() {
  return new CreateServiceAccountDtoModelSelector()
}

export const createServiceAccountDtoModelPrimitives = selectFromCreateServiceAccountDto().uuid.token.expiresOn
